module.exports = __webpack_public_path__ + "static/media/concept_for_toy_store_mural_of_vintage_toys_2012.aa8f224a.webp";